module.exports = __webpack_public_path__ + "static/img/pay.86ba1da5.png";